import { motion } from 'framer-motion';

const MarqueeSlider = () => {
  const projects = [
    'FARTCAT', 'BONKU', 'VOOZ', 'REBATE'
  ];

  return (
    <div className="relative overflow-hidden py-8">
      {/* Gradient fades on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10"></div>
      
      <div className="inline-flex gap-12 whitespace-nowrap animate-marquee">
        {/* Create six identical sets for smoother seamless loop */}
        {[1, 2, 3, 4, 5, 6].map((setNum) => (
          <div key={setNum} className="inline-flex gap-12">
            {projects.map((project, index) => (
              <div
                key={`${setNum}-${index}`}
                className="inline-flex items-center justify-center px-8 py-4 border border-primary/30 bg-surface min-w-[150px]"
              >
                <span className="font-space-mono text-primary text-xl font-bold tracking-widest">
                  ${project}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarqueeSlider;
